import { useLocation } from "@tanstack/react-router"

import { cn } from "@/lib/utils"

// Map path segments to theme classes
// Routes not listed use :root (light theme) by default
const THEME_BY_SEGMENT: Record<string, string> = {
  // Brand theme
  about: "brand",
  privacy: "brand",
  terms: "brand",
  ucm: "brand",
  yellowpage: "brand",
  embed: "brand",
  // Dark theme
  insights: "dark",
  bills: "dark",
  solar: "dark",
  login: "dark",
  portal: "dark",
  // Reputation theme
  reputation: "reputation",
}

export function BodyWrapper({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation()
  const segments = pathname.split("/").filter(Boolean)

  let theme = undefined
  if (segments.length === 0) {
    // Homepage uses default light theme.
    theme = undefined
  } else {
    // Other pages use the THEME_BY_SEGMENT object.
    const matchedSegment = segments.find((s) => THEME_BY_SEGMENT[s])
    theme = matchedSegment ? THEME_BY_SEGMENT[matchedSegment] : undefined
  }

  return <div className={cn(theme)}>{children}</div>
}
